exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np.loading[data-v-4a416c34] {\n  clear: both;\n}\ntd[data-v-4a416c34] {\n  word-break: break-all;\n  min-width: 90px;\n}\n", ""]);

// exports
